import styled from 'styled-components';

export type DrawerTabKey =
  | 'overview'
  | 'routing'
  | 'ai_agent'
  | 'people';

type DrawerTabsProps = {
  activeTab: DrawerTabKey;
  onChange: (next: DrawerTabKey) => void;
};

const Row = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
  overflow: visible;
  padding: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
`;

const TabButton = styled.button<{ $active?: boolean }>`
  min-height: 36px;
  margin-bottom: -1px;
  border-radius: 12px 12px 0 0;
  border: 1px solid ${({ $active }) => ($active ? 'rgba(224, 161, 94, .34)' : 'rgba(255, 255, 255, .08)')};
  border-bottom-color: transparent;
  background: ${({ $active }) => ($active ? 'rgba(224, 161, 94, .1)' : 'rgba(255, 255, 255, .02)')};
  color: ${({ $active }) => ($active ? '#F8EBD6' : '#CBD2E1')};
  font-size: 11px;
  font-weight: 900;
  letter-spacing: .02em;
  padding: 0 12px;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    border-color: rgba(224, 161, 94, .34);
    background: ${({ $active }) => ($active ? 'rgba(224, 161, 94, .1)' : 'rgba(255, 255, 255, .06)')};
  }
`;

const ALL_TABS: { key: DrawerTabKey; label: string }[] = [
  { key: 'overview', label: 'Overview' },
  { key: 'routing', label: 'Routing' },
  { key: 'ai_agent', label: 'AI Agent' },
  { key: 'people', label: 'Team' },
];

export function DrawerTabs({ activeTab, onChange }: DrawerTabsProps) {
  return (
    <Row aria-label="Node detail tabs">
      {ALL_TABS.map((tab) => (
        <TabButton
          key={tab.key}
          type="button"
          $active={activeTab === tab.key}
          onClick={() => onChange(tab.key)}
        >
          {tab.label}
        </TabButton>
      ))}
    </Row>
  );
}
